/**
 * author: Alex Lai
 * Support Website: https://laialex.com
 * Email: alex@laialex.com
 * Create Time: 2025/3/21
 */

export const CommonUtils = {
  // eslint-disable-next-line camelcase
  getSsoUrl: function (redirect_uri, clientId = 8755664) {
    var baseUrl = 'https://passport.alaikis.com/oauth/v2/authorize'
    var queryParams = {}
    queryParams.response_type = 'code'
    queryParams.scope = 'get_user_info'
    // eslint-disable-next-line camelcase
    queryParams.redirect_uri = redirect_uri
    queryParams.client_id = clientId
    return baseUrl + '?' + new URLSearchParams(queryParams).toString()
  }
}



// WEBPACK FOOTER //
// ./src/utils/base_apis.js